import globals from "../partials/global-variables";

export default {
  container: {
    maxWidth: "770px",
    width: "65%",
    height: "10px",
    background: globals.colors.gray,
    "& .gradientProgressBar": {
      zIndex: 5,
      width: "100%",
      height: "100%",
      transition: "width 1s ease-in-out",
      background: "linear-gradient(to right,#068acc 1%,#068acc 20%,#45b931 90%)"
    }
  }
};
